import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard.css";

// Icons
import {
  MdDashboard, MdGroup, MdAccountBalance, MdCorporateFare,
  MdRestaurant, MdLibraryBooks, MdAdUnits, MdContentCopy,
  MdOutlineTv
} from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { PiSignpostThin, PiNewspaperThin } from "react-icons/pi";
import { SlEvent } from "react-icons/sl";

// Dashboard Components
import LocationData from "./Location";
import EventData from "./Event";
import NewsData from "./News";
import AffiliationData from "./Affiliation";
// import CircularNotice from "./CircularNotice";
// import ContactData from "./Contact";`
import ManagementData from "./Management";
import CompListData from "./CompList";
import ReservationData from "./Reservation";
// import Member from "./Member";
import Banner from "./Banner";
// import OfferPage from "./OfferPage";
import Scheme from "./Scheme";
import Booking from "./Booking";
// import MessageSettings from "./OTP";
import Saccount from "./Statementaccount";
import BarandRestaurant from "./BarandRestaurant";
// import ProductList from "./ProductList";
// import OrderList from "./OrderList";
import BarDetail from "./BarDetail";
import FacilityManager from "./Garden";
import Facility from "./facility";
import OfficeBearers from "./OfficeBearers";
import RoomTypeTable from "./Roomtype";
import SportsSlot from "./SportsSlot";
import LawnSlot from "./LawnSlot";
import NoticeList from "./NotceList";
import Sundry from "./Sundry";
import CourtsManagement from "./sportscourt";



function DashboardCard({ icon, title, count, onClick }) {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
      <div
        onClick={onClick}
        className="card p-4 border-0 card-location"
        style={{ backgroundColor: "#fff", cursor: "pointer" }}
      >
        <div className="d-flex justify-content-between">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "#03a9f5", width: 80, height: 80, borderRadius: 50 }}
          >
            {icon}
          </div>
          <div>
            <div style={{ fontSize: "22px", fontWeight: 300, color: "#000" }}>{title}</div>
            <div style={{ fontSize: "16px", fontWeight: 400, color: "#000" }}>{count}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const LoginID = sessionStorage.getItem("LoginID");
    if (!LoginID) {
      navigate("/", { replace: true }); // <-- Updated route
    }
  }, [navigate]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const sidebar = document.querySelector(".sidebar");
      if (showSidebar && sidebar && !sidebar.contains(event.target)) {
        setShowSidebar(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [showSidebar]);

  useEffect(() => {
    window.scrollTo(0, 0); // <-- Scroll to top on section change
  }, [activeSection]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/admin", { replace: true });
  };

  const handleNavClick = (section) => {
    setActiveSection(section.toLowerCase().replace(/\s/g, ""));
    setShowSidebar(false);
  };

  const dataList = [
    {
      title: "Location",
      key: "location",
      icon: <PiSignpostThin size={30} color="#fff" />,
    },
    {
      title: "Events",
      key: "events",
      icon: <SlEvent size={28} color="#fff" />,
    },
    {
      title: "News",
      key: "news",
      icon: <PiNewspaperThin size={30} color="#fff" />,
    },
    // {
    //   title: "NoticeList",
    //   key: "noticelist",
    //   icon: <PiNewspaperThin size={30} color="#fff" />,
    // },
    // {
    //   title: "Circular Notices",
    //   key: "circularnotice",
    //   icon: <MdLibraryBooks size={32} color="#fff" />,
    // },
  ];

  return (
    <div className="dashboard-wrapper d-flex flex-column" style={{ height: "100vh" }}>
      <div className="d-flex justify-content-between align-items-center px-4 py-3 text-white" style={{ backgroundColor: "#582b33", position: "sticky", top: 0, zIndex: 1020 }}>
        <div className="d-flex align-items-center">
          <button className="btn btn-dark d-lg-none me-3" onClick={() => setShowSidebar(!showSidebar)}>
            <FiMenu size={24} />
          </button>
          <h4 className="m-0">Admin Panel</h4>
        </div>
        <Dropdown align="end">
          <Dropdown.Toggle variant="light" id="dropdown-user" className="d-flex align-items-center">
            <FaUserCircle size={24} className="me-2" />
            <span style={{ fontSize: "16px", fontWeight: 500 }}>Admin</span>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ zIndex: "1050" }}>
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="d-flex flex-grow-1 overflow-hidden">
        <div className={`sidebar  ${showSidebar ? "show" : ""}`}>
          {[{ icon: <MdDashboard />, label: "Dashboard", key: "dashboard" },
            { icon: <PiSignpostThin />, label: "Location", key: "location" },
            { icon: <PiNewspaperThin />, label: "News", key: "news" },
            { icon: <PiNewspaperThin />, label: "NoticeList", key: "noticelist" },
            { icon: <SlEvent />, label: "Events", key: "events" },
            // { icon: <MdGroup />, label: "Members", key: "members" },
            { icon: <MdAccountBalance />, label: "Statement of Account", key: "account" }].map((item) => (
            <div key={item.key} className="sidebar-item d-flex align-items-center " onClick={() => handleNavClick(item.key)}>
              {item.icon} <span className="ms-2">{item.label}</span>
            </div>
          ))}

          <div>
            <div className="sidebar-item d-flex align-items-center  " onClick={() => setOpenDropdown(openDropdown === "management" ? null : "management")}>
              <MdCorporateFare style={{ marginRight: 10 }} /> <span className="ms-2">Management</span>
            </div>
            {openDropdown === "management" && (
              <div className="ms-4">
                {/* {["affiliation", "circularnotice", "contact", "management", "past management"].map((key) => ( */}
                {["affiliation", "management", "past management"].map((key) => (
                  <div className="sidebar-subitem" key={key} onClick={() => handleNavClick(key)}>
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <div className="sidebar-item d-flex align-items-center " onClick={() => setOpenDropdown(openDropdown === "Booking Type" ? null : "Booking Type")}>
              <MdContentCopy style={{ marginRight: 10 }} /> <span className="ms-2">Booking </span>
            </div>
            {openDropdown === "Booking Type" && (
              <div className="ms-4">
                <div className="sidebar-subitem" onClick={() => handleNavClick("roomsection")}>Room Type</div>
                <div className="sidebar-subitem" onClick={() => handleNavClick("lawnsection")}>Lawn & Hall Type</div>
                <div className="sidebar-subitem" onClick={() => handleNavClick("sports")}>sports Type</div>
                {/* <div className="sidebar-subitem" onClick={() => handleNavClick("sundry")}>sundry</div> */}
                <div className="sidebar-subitem" onClick={() => handleNavClick("bookingreport")}>Booking Report</div>
              </div>
            )}
          </div>
          <div>
            <div className="sidebar-item d-flex align-items-center " onClick={() => setOpenDropdown(openDropdown === "Facility" ? null : "Facility")}>
              <MdContentCopy style={{ marginRight: 10 }} /><span className="ms-2">Facility</span> 
            </div>
            {openDropdown === "Facility" && (
              <div className="ms-4">
                <div className="sidebar-subitem" onClick={() => handleNavClick("facilitysection")}>Facility Group</div>
                <div className="sidebar-subitem" onClick={() => handleNavClick("facilitygroup")}>Facility </div>
              </div>
            )}
          </div>

          {/* <div>
            <div className="sidebar-item d-flex align-items-center " onClick={() => setOpenDropdown(openDropdown === "Service Facility" ? null : "Service Facility")}>
              <MdRestaurant style={{ marginRight: 10 }} /><span className="ms-2">Service Facility</span> 
            </div>
            {openDropdown === "Service Facility" && (
              <div className="ms-4">
                {["productlist", "orderlist"].map((key) => (
                  <div className="sidebar-subitem" key={key} onClick={() => handleNavClick(key)}>
                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1")}
                  </div>
                ))}
              </div>
            )}
          </div> */}

          {/* <div className="sidebar-item d-flex align-items-center mb-3" onClick={() => handleNavClick("banner")}>
            <BiChalkboard style={{ marginRight: 10 }} /> Banner
          </div> */}
          {/* <div className="sidebar-item d-flex align-items-center " onClick={() => handleNavClick("offerpage")}>
            <MdOutlineTv style={{ marginRight: 10 }} /> <span className="ms-2">Offers</span> 
          </div> */}

          {/* <div className="sidebar-item d-flex align-items-center " onClick={() => handleNavClick("otp")}>
            <MdAdUnits style={{ marginRight: 10 }} /> <span className="ms-2">OTP</span> 
          </div> */}
        </div>

        <div className="main-content flex-grow-1 overflow-y-auto">
          {activeSection === "dashboard" && (
            <div className="row">
              {dataList.map(({ title, count, icon, key }) => (
                <DashboardCard
                  key={key}
                  title={title}
                  count={count}
                  icon={icon}
                  onClick={() => handleNavClick(key)}
                />
              ))}
            </div>
          )}
          {activeSection === "location" && <LocationData />}
          {/* {activeSection === "location" && <BarDetail  />} */}
          {activeSection === "events" && <EventData />}
          {activeSection === "sundry" && <Sundry/> }
          {activeSection === "news" && <NewsData />}
          {activeSection === "noticelist" && <NoticeList/> }
          {activeSection === "affiliation" && <AffiliationData />}
          {/* {activeSection === "circularnotice" && <CircularNotice />}
          {activeSection === "contact" && <ContactData />} */}
          {activeSection === "management" && <ManagementData />}
          {activeSection === "complist" && <CompListData />}
          {/* {activeSection === "bardetail" && <BarDetail />} */}
          {/* {activeSection === "productlist" && <ProductList />}
          {activeSection === "orderlist" && <OrderList />} */}
          {activeSection === "bookingreport" && <ReservationData />}
          {/* {activeSection === "members" && <Member />} */}
          {activeSection === "banner" && <Banner />}
          {/* {activeSection === "offerpage" && <OfferPage />} */}
          {activeSection === "scheme" && <Scheme />}
          {activeSection === "barandrestaurant" && <BarandRestaurant />}
          {activeSection === "facilitysection" && <FacilityManager />}
          {activeSection === "facilitygroup" && <Facility />}
          {activeSection === "account" && <Saccount />}
          {activeSection === "booking" && <Booking />}
          {/* {activeSection === "otp" && <MessageSettings />} */}
          {activeSection === "pastmanagement" && <OfficeBearers/> }
          {activeSection === "roomsection" && <RoomTypeTable/> }
          {activeSection === "lawnsection" && <LawnSlot/> }
          {/* {activeSection === "sports" && <SportsSlot/> } */}
          {activeSection === "sports" && <CourtsManagement/> }
        </div>
      </div>
    </div>
  );
}